import { ENV_VARS_LOCAL_STORAGE_KEY } from '@/configs/constants';

export const storeEnvToLocalStorage = (config: { [key: string]: string }) => {
  localStorage.setItem(ENV_VARS_LOCAL_STORAGE_KEY, JSON.stringify(config));
};

export const getEnvValue = (key: string): string => {
  if (typeof window === 'undefined') {
    return process.env[key] as string;
  }
  const configString = localStorage.getItem(ENV_VARS_LOCAL_STORAGE_KEY);
  const config = configString ? JSON.parse(configString) : {};
  return config[key];
};

export const getPageReqPath = (url: string) => {
  return url.replace(/^.*\/\/[^\/]+/, '');
};

export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts?.pop()?.split(';').shift();
};
